import classNames from "classnames";
import TextButton from "../textButton/TextButtonLegacy";

type PromoTextWithActionProps = {
  accentColor?: "pro-blue" | "cerise";
  text: string;
  actionText: string;
  href: string;
  onClick?: () => void;
  wrapperClasses?: string;
  titleClasses?: string;
};

const PromoTextWithAction = ({
  text,
  actionText,
  onClick,
  href,
  wrapperClasses,
  titleClasses,
  accentColor = "pro-blue",
}: PromoTextWithActionProps) => {
  return (
    <div
      data-testid={"promoTextWithAction__wrapper"}
      className={classNames(
        "flex flex-col items-center justify-center border-b-2 border-t-2 border-b-mono-10 border-t-mono-10",
        wrapperClasses
      )}
    >
      <div className={"mb-5 w-full"}>
        <p
          className={classNames(
            "text-center text-[24px] leading-[130%]",
            {
              "text-pro-blue": accentColor === "pro-blue",
              "text-cerise": accentColor === "cerise",
            },
            titleClasses
          )}
        >
          {text}
        </p>
      </div>
      <div className={"flex w-full justify-center"}>
        <TextButton
          onClick={onClick}
          href={href}
          colour={"black"}
          withIcon={true}
        >
          {actionText}
        </TextButton>
      </div>
    </div>
  );
};

export default PromoTextWithAction;
